import { TaskCompletionStateFragment } from "gql/graphql";

/**
 * Срок задачи строкой OffsetDateTime: у однократной — её срок, у серии — следующее
 * срабатывание. `null` — срока нет или серия закончилась; как показать пустоту,
 * решает вызывающий.
 */
export function getTaskDueDate(
  task: TaskCompletionStateFragment,
): string | null {
  const { completion } = task;

  if (completion.__typename === "RecurringCompletionDto") {
    return completion.nextDueDate ?? null;
  }

  return completion.dueDate ?? null;
}
